// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { registerLazy } from "./lazy"

// Loaded on demand, not bundled here (controllers/lazy.js); keep these two
// out of this file if the manifest is regenerated.
registerLazy(application, "lair", () => import("./lair_controller"))
registerLazy(application, "commons", () => import("./commons_controller"))

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)
import ZonePickerController from "./zone_picker_controller"
application.register("zone-picker", ZonePickerController)
import NamePickerController from "./name_picker_controller"
application.register("name-picker", NamePickerController)
import DoorEggController from "./door_egg_controller"
application.register("door-egg", DoorEggController)
import ShiftController from "./shift_controller"
application.register("shift", ShiftController)

import SoundController from "./sound_controller"
application.register("sound", SoundController)

import WardrobeController from "./wardrobe_controller"
application.register("wardrobe", WardrobeController)

import MewsController from "./mews_controller"
application.register("mews", MewsController)

import GroundsMapController from "./grounds_map_controller"
application.register("grounds-map", GroundsMapController)

import WarrenMapController from "./warren_map_controller"
application.register("warren-map", WarrenMapController)

import GameShellController from "./game_shell_controller"
application.register("game-shell", GameShellController)

import BoutController from "./bout_controller"
application.register("bout", BoutController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import LookAgainController from "./look_again_controller"
application.register("look-again", LookAgainController)

import JoustController from "./joust_controller"
application.register("joust", JoustController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import PurseController from "./purse_controller"
application.register("purse", PurseController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import AnnounceController from "./announce_controller"
application.register("announce", AnnounceController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatNoticeController from "./chat_notice_controller"
application.register("chat-notice", ChatNoticeController)

import PushController from "./push_controller"
application.register("push", PushController)

import OddsController from "./odds_controller"
application.register("odds", OddsController)

import ForgeController from "./forge_controller"
application.register("forge", ForgeController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)

import PlayTogetherController from "./play_together_controller"
application.register("play-together", PlayTogetherController)

import ScreenFieldsController from "./screen_fields_controller"
application.register("screen-fields", ScreenFieldsController)

import GaugesController from "./gauges_controller"
application.register("gauges", GaugesController)

import RailTabsController from "./rail_tabs_controller"
application.register("rail-tabs", RailTabsController)

import TourController from "./tour_controller"
application.register("tour", TourController)

import LoreController from "./lore_controller"
application.register("lore", LoreController)
